export default {
  200: "成功",
  4001: "未登陆",
  4002: "非法请求",
  4003: "服务繁忙，请稍后重试",
  4005: "异常请求",
  default: "系统未知错误，请反馈给管理员",
};
